module.exports = __webpack_public_path__ + "img/data-center09.188e8d45.png";